module.exports = __webpack_public_path__ + "static/img/banner-empleo-home-768x1024.30448b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-empleo-home-768x1024.jpg
// module id = 2hmj
// module chunks = 47